import { FC } from 'react'

import {
  BorderRadius8,
  GreyGrey30,
  GreyWhite,
  ShadowL,
  Flex
} from '@sequencehq/core-components'
import { NodeType } from 'Automations/nodeDefinitions/types'
import { AddNodeItem } from '../../hooks'
import { NodeIconButton } from './NodeIconButton'

/**
 * A horizontal bar of node icons mirroring the bottom AddNodeToolbar. Shared by
 * the inline edge insert picker and the connection-drop picker. The bar only
 * renders the options — callers own placement (popover, overlay, etc.).
 */
export const NodePickerBar: FC<{
  items: AddNodeItem[]
  onSelect: (item: AddNodeItem) => void
  // Fired on hover-enter only; the caller decides how long to retain it.
  onHoverItem?: (nodeType: NodeType) => void
  itemTestId: (nodeType: NodeType) => string
  'data-testid'?: string
}> = ({
  items,
  onSelect,
  onHoverItem,
  itemTestId,
  'data-testid': dataTestId
}) => (
  <Flex
    data-testid={dataTestId}
    backgroundColor={GreyWhite}
    border={`${GreyGrey30} 1px solid`}
    borderRadius={BorderRadius8}
    boxShadow={ShadowL}
    padding="8px"
    gap="8px"
  >
    {items.map(item => (
      <NodeIconButton
        key={item.nodeType}
        nodeType={item.nodeType}
        data-testid={itemTestId(item.nodeType)}
        onClick={() => onSelect(item)}
        onMouseEnter={
          onHoverItem ? () => onHoverItem(item.nodeType) : undefined
        }
      />
    ))}
  </Flex>
)
